const directDispatchHeader = {
  'Shipment Number': 'shipment_number',
  'Delivery Number': 'delivery_number',
  'Transporter Ref Id': 'transporter',
  'Vehicle Name': 'vehicle_type',
  'Vehicle Number': 'vehicle_number',
  'Depot Ref ID': 'depot_ref_id',
  'Gate Ref ID': 'gate_ref_id',
  'Ship To': 'ship_to',
  'Sold To': 'sold_to',
  'Material Code': 'material_code',
  Quantity: 'quantity',
  'Quantity Unit': 'quantity_unit',
  Weight: 'weight',
  'Weight Unit': 'weight_unit',
  Volume: 'volume',
  'Volume Unit': 'volume_unit',
  Division: 'division',
  Category: 'category',
  Movement: 'movement',
  'LR number': 'lr_number',
  'Invoice Number': 'invoice_number',
  'Invoice Amount': 'invoice_amount',
  'Invoice Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'invoice_date',
  MRP: 'mrp',
  'Dispatched Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'dispatched_date',
  'EwayBill Number': 'eway_bill_number',
  'EwayBill Date': 'eway_bill_date'
};

const OrdersConstants = {
  SingleOrderMaterialHeaders: {
    'Delivery Number': 'delivery',
    'Material SKU Code': 'material_code',
    Quantity: 'quantity',
    BUn: 'billing_unit',
    Weight: 'gross_weight',
    WUn: 'weight_unit',
    Volume: 'volume',
    VUn: 'volume_unit',
    Shpt: 'gate_ref_id',
    'Ship-to': 'ship_to_ref_id',
    'Sold-to': 'sold_to_ref_id',
    'Invoice Number': 'invoice_number',
    'Invoice Value': 'invoice_amount',

    // 'Sales Order No': 'custom_fields.so_number',
    // 'Material Code': 'material_code',
    // 'Material type Desc': '',
    // 'Quantity in SKU': 'quantity',
    // 'Sales Unit': 'billing_unit',
    // 'Gross Weight in MT': 'gross_weight',
    // Plant: 'gate_ref_id',
    // 'Ship-To': 'ship_to_ref_id',
    // 'Sold-To': 'sold_to_ref_id',
    // 'Total Value With GST': 'invoice_amount',
    // 'Bill Number': 'invoice_number',
    // 'Billing Date': '',
    // 'Sales Organization': 'shipment_org',

    // 'Pando Order No': 'order_no',
    // Delivery: 'delivery',
    // Material: 'material_code',
    // 'Bill of lading Number': 'lr_number',
    // 'Delivery quantity': 'quantity',
    // BUn: 'billing_unit',
    // 'Gross weight': 'gross_weight',
    // WUn: 'weight_unit',
    // Volume: 'volume',
    // VUn: 'volume_unit',
    // 'Created on': 'created_on',
    // ShPt: 'gate_ref_id',
    // 'Ship-to': 'ship_to_ref_id',
    // 'Sold-to pt': 'sold_to_ref_id',
    // 'SOrg.': 'shipment_org',
    // Item: 'item',
  },
  searchBy: ['order_number', 'transporter', 'consignee', 'lr_number', 'vehicle_number', 'indent_id'],
  filterBy: ['loading_date', 'created_at'],
  OrderType: {
    CONTRACT: 0,
    OPEN: 1,
    NO_FREIGHT: 2,
    MARKET: 3,
  },
  FreightUnit: {
    PER_TRIP: 1,
    PER_TON: 2,
    PER_KG: 3,
    PER_CFT: 4,
    PER_PACKAGE: 5,
    PER_CASE: 6,
    PER_BOX: 7,
    PER_KM: 8,
  },
  WeightConverter: {
    per_trip: 'per_trip',
    per_kg: 'kg',
    per_ton: 't',
  },
  Movement: {
    SECONDARY: 1,
    PRIMARY: 2,
    INWARD: 3,
    RETURNS: 4,
  },
  MovementTypes: {
    SECONDARY: 'Secondary',
    PRIMARY: 'Primary',
  },
  BulkDeliverHeaders: {
    Delivery: 'delivery_no',
    Shipment: 'material_ref_id',
    DD: 'DD',
    MM: 'MM',
    YYYY: 'YYYY',
  },
  BULK_UPLOAD_HEADER: {
    'ORDER NO': 'sno',
    'DELIVERY TYPE': 'delivery_type',
    'VEHICLE TYPE': 'vehicle_type',
    'TRANSPORTER REFID': 'transporter_refid',
    'PICKUP POINT': 'pick_up',
    'VEHICLE REQUIREMENT DATE(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'loading_date',
    'SHIP TO': 'ship_to',
    'SOLD TO': 'sold_to',
    'NO OF VEHICLE(S)': 'vehicle_count',
    'PICKUP POINT TYPE': 'pick_up_type',
    'SHIP TO TYPE': 'ship_to_type',
    'DELIVERY NUMBER': 'delivery_number',
    'SHIPMENT NUMBER': 'shipment_number',
  },
  BULK_UPLOAD_OPTIONAL_HEADER: {
    DOCKS: 'docks',
    'INDENT TYPE': 'indent_type',
    'BASE FREIGHT': 'base_freight',
    'FREIGHT UNIT': 'freight_unit',
    'VEHICLE NUMBER': 'vehicle_number',
    'COMMENTS': 'comments',
  },
  BULK_UPLOAD_MATERIAL_HEADER: {
    'MATERIAL TYPE': 'material_type',
    'MATERIAL DELIVERY NUMBER': 'material_delivery_number',
    'MATERIAL CODE': 'material_code',
    'MATERIAL WEIGHT': 'material_weight',
    'MATERIAL WEIGHT UNIT': 'material_weight_unit',
    'MATERIAL VOLUME': 'material_volume',
    'MATERIAL VOLUME UNIT': 'material_volume_unit',
    'MATERIAL QUANTITY': 'material_quantity',
    'MATERIAL QUANTITY UNIT': 'material_quantity_unit',
    'INVOICE NUMBER': 'invoice_number',
    'INVOICE AMOUNT': 'invoice_amount',
    'INVOICE DATE': 'invoice_date',
    MRP: 'mrp',
    DIVISION: 'division',
    CATEGORY: 'category',
  },
  BULK_UPLOAD_PACKAGE_HEADER: {
    'PACKAGE ID': 'package_id',
    'PACKAGE REFERENCE ID': 'package_reference_id',
    'PACKAGE CODE': 'package_code',
    'PACKAGE WEIGHT': 'package_weight',
    'PACKAGE WEIGHT UNIT': 'package_weight_unit',
    'PACKAGE VOLUME': 'package_volume',
    'PACKAGE VOLUME UNIT': 'package_volume_unit',
    'PACKAGE QUANTITY': 'package_quantity',
    'PACKAGE QUANTITY UNIT': 'package_quantity_unit',
  },
  DIRECT_DELIVERY_BULK_UPLOAD_HEADER: Object.assign({
      'Reported Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'reported_date',
      'Released Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'released_date',
      'Unloading Start Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'unloading_start_at',
      'Unloading End Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'unloading_end_at',
      Shortage: 'shortage',
      Damage: 'damage',
      'Carton Damage': 'carton_damage',
  }, directDispatchHeader),
  DIRECT_DISPATCH_BULK_UPLOAD_HEADER: Object.assign({
    'Driver Phone Number': 'driver_phone_number',
    'Requirement Date(YYYY-MM-DD or YYYY-MM-DD HH:mm:ss)': 'requirement_date',
    'Indent Type': 'indent_type',
    'Freight Type': 'freight_type',
    'Driver Name': 'driver_name',
  },directDispatchHeader),
  DEFAULT_VALUES: {
    LOADER_AVAILABLE: 0,
    PAID_BY: 0,
    UNLOADER_AVAILABLE: 0,
  },
  openFreightChargeAllowed: [
    'OPEN',
  ],
  deliveryType: {
    ftl: 'FTL',
    ptl: 'PTL',
  },
  slaTriggerJobTypes: {
    ACCEPTANCE: 'ACCEPTANCE',
    ARRIVAL: 'ARRIVAL',
  },
  SLAExpiry: {
    ACCEPTANCE: 5 * 60 * 1000, // 12 * 60 * 60 * 1000,
    ASSIGNMENT: 10 * 60 * 1000, // 12 * 60 * 60 * 1000,
    // HACK: Should take from config, prod/demo/dev/Staging - 5:30 PM
    ARRIVAL: (17 + 0.5) * 60 * 60 * 1000,
    INDENT_CUTOFF_TIME_FOR_SLA: 12 * 60 * 60 * 1000, // indent creation cutoff time
  },
  erpMaterialHeader: [
    'indent_no',
    'delivery_number',
    'mrp_price',
    'material_code',
    'depot_ref_id',
    'gate_ref_id',
    'division',
    'quantity',
    'quantity_unit',
    'weight',
    'weight_unit',
    'volume',
    'volume_unit',
    'ship_to',
    'sold_to',
    'type',
    'invoice_number',
    'invoice_amount',
    // 'invoice_date',
    'category',
  ],
  defaultMaterialInvoiceStatus: [
    'indented',
    'truck_change_requested',
    'indent_rejected',
    'indent_accepted',
    'truck_assigned',
    'truck_arrived',
    'dispatched',
    'truck_rejected',
    'loading_started',
    'loading_ended',
    'indent_assign_due',
    'indent_accept_due',
    'indent_arrived_due',
    'delivery_pending',
    'reported',
  ],
  unloadingReportedStatus: 999,
  lrCopies: [
    'CONSIGNOR COPY',
    'CONSINGEE COPY',
    'MATERIAL SHORTAGE & DAMAGE ANNEXURE',
    'TRANSPORTER COPY',
    'DRIVER COPY',
  ],
  materialReason: {
    1: 'Material not found',
    2: 'Ship to not found',
    3: 'Sold to not found',
    4: 'Gate not found',
    5: 'Weight / Volume missing',
    6: 'Duplicate Deliveries',
    7: 'Weight/ volume unit not available',
    8: 'Quantity missing',
  },
  EditableType: {
    NON_EDITABLE: 0,
    EDITABLE: 1,
    INCREMENT_ONLY: 2,
    DECREMENT_ONLY: 3,
  },
  CHARGEABLE_WEIGHT_BULK_UPLOAD_HEADER: {
    'Indent Number/ Shipment Number': 'indent_number',
    'LR Number': 'lr_number',
    Weight: 'weight',
    Volume: 'volume',
    Quantity: 'quantity',
    'Quantity Unit': 'quantity_unit',

  },
  CHARGEABLE_WEIGHT_BULK_UPLOAD_HEADER_ERP: {
    indent_number: 'indent_number',
    lr_number: 'lr_number',
    weight: 'weight',
    volume: 'volume',
    quantity: 'quantity',
    quantity_unit: 'quantity_unit',
  },
  LR_BULK_UPLOAD_HEADER: {
    'Indent Number*': 'indent_number',
    'PickUp Depot Ref Id*': 'source_ref_id',
    'Pickup Gate Ref Id': 'gate_ref_id',
    'Ship To Ref Id*': 'ship_to_ref_id',
    'Sold To ref Id*': 'sold_to_ref_id',
    'Lr Number*': 'lr_number',
    Division: 'material_division',
  },
};

module.exports = { OrdersConstants };
